import { useEffect, useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const useNavigationBlock = (shouldBlock = true) => {
  const [showModal, setShowModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  const callback = searchParams.get("callback")


  // Handle browser back/forward button
  useEffect(() => {
    if (!shouldBlock) return;

    let isNavigating = false;

    const handlePopState = (event) => {
      if (isNavigating) {
        isNavigating = false;
        return;
      }

      // Skip confirmation if callback parameter is present
      if (callback) {
        return;
      }

      // Prevent the navigation by pushing the current state back
      window.history.pushState(null, null, window.location.pathname);

      setShowModal(true);
      setPendingNavigation(() => () => {
        isNavigating = true;
        window.history.back();
      });
    };

    // Add a history entry to catch back navigation
    window.history.pushState(null, null, window.location.pathname);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [shouldBlock, callback]);

  const confirmNavigation = useCallback(() => {
    setShowModal(false);
    if (pendingNavigation) {
      pendingNavigation();
    }
    setPendingNavigation(null);
  }, [pendingNavigation]);

  const cancelNavigation = useCallback(() => {
    setShowModal(false);
    setPendingNavigation(null);
  }, []);

  // Custom navigate function that respects blocking
  const navigateWithConfirm = useCallback((to, options = {}) => {
    if (!shouldBlock || callback) {
      navigate(to, options);
      return;
    }

    setShowModal(true);
    setPendingNavigation(() => () => {
      navigate(to, options);
    });
  }, [shouldBlock, navigate, callback]);

  return {
    showModal,
    confirmNavigation,
    cancelNavigation,
    navigateWithConfirm,
  };
};

export default useNavigationBlock;
